import { createClient } from '@supabase/supabase-js';

// Supabase configuration
// Set these environment variables in your .env.local file:
// REACT_APP_SUPABASE_URL=https://YOUR_PROJECT_REF.supabase.co
// REACT_APP_SUPABASE_ANON_KEY=your_anon_key

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

// Fail loudly at startup: a client created with an empty URL only fails later with
// confusing network errors on every request.
if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error(
    'Missing Supabase environment variables. Please set REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_ANON_KEY (e.g. in .env.local) and rebuild.'
  );
}

export const SUPABASE_ANON_KEY = supabaseAnonKey;

// Single Supabase client for dispatch schema (this app's data)
// Use .schema('common') for user_apps queries
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  db: {
    schema: 'dispatch'
  },
  auth: {
    autoRefreshToken: true,
    persistSession: true
  }
});

// Edge Functions base URL
export const FUNCTIONS_URL = `${supabaseUrl}/functions/v1`;
